module.exports = __webpack_public_path__ + "fe3c39db88b577c88ff0f417c9b2f101.svg";